export const personalityCards = {
  ope: {
    active: [
      {
        id: "O02",
        band: "ope",
        files: ["ucdsdi", "htydnk"],
        scheme: "dark",
        active: true,
        captions: ["Do not enjoy art", "Enjoy art"]
      },
      {
        id: "O03",
        band: "ope",
        files: ["v4wznn", "otppwh"],
        scheme: "dark",
        active: true,
        captions: [
          "Value tradition and order",
          "Value difference and expression"
        ]
      },
      {
        id: "O04",
        band: "ope",
        files: ["6hjpnn", "rqdi5f"],
        scheme: "dark",
        active: true,
        captions: ["Have realistic thoughts", "Have a vivid imagination"]
      },
      {
        id: "O05",
        band: "ope",
        files: ["omm2e5", "tbvnyr"],
        scheme: "dark",
        active: true,
        captions: ["Conservative", "Expressive"]
      },
      {
        id: "O06",
        band: "ope",
        files: ["ia4pb5", "d5w5c0"],
        scheme: "dark",
        active: true,
        captions: [
          "Prefer my living spaces to be clean and modern",
          "Prefer environments that are quirky, different and not the ´norm´"
        ]
      },
      {
        id: "O08",
        band: "ope",
        files: ["79n2wd", "gmc7v6"],
        scheme: "dark",
        active: true,
        captions: ["Prefer realism", "Prefer abstract"]
      },
      {
        id: "O09",
        band: "ope",
        files: ["ns0drp", "ipxar1"],
        scheme: "dark",
        active: true,
        captions: [
          "Love doing things the way I have done them in the past",
          "Love to think up new ways of doing things"
        ]
      },
      {
        id: "O13",
        band: "ope",
        files: ["umfwc1", "82zoew"],
        scheme: "dark",
        active: true,
        captions: [
          "Enjoy work that is concrete and traditional",
          "Enjoy work that is creative and imaginative"
        ]
      },
      {
        id: "O15",
        band: "ope",
        files: ["1qlnlw", "xwtnz3"],
        scheme: "dark",
        active: true,
        captions: [
          "Value familiar and comfortable experiences",
          "Value different and challenging experiences"
        ]
      },
      {
        id: "E09",
        band: "ope",
        files: ["0ym1g4", "o5lmfd"],
        scheme: "dark",
        active: true,
        captions: ["Love to blend in", "Love to stand out"]
      }
    ],
    research: [
      {
        id: "O12",
        band: "ope",
        files: ["1898i8", "rsjitu"],
        scheme: "dark",
        active: false,
        captions: [
          "Like to watch theatre plays",
          "LIke to immerse myself in the live experience of theatre"
        ]
      },
      {
        id: "O11",
        band: "ope",
        files: ["fnospk", "jmqxsz"],
        scheme: "dark",
        active: false,
        captions: [
          "Solve problems with a direct approach",
          "Think creatively to solve problems"
        ]
      },
      {
        id: "O10",
        band: "ope",
        files: ["du31fu", "4klf7y"],
        scheme: "dark",
        active: false,
        captions: ["Focus on a single idea", "Full of ideas"]
      },
      {
        id: "O07",
        band: "ope",
        files: ["y2ms3t", "2jfzba"],
        scheme: "dark",
        active: false,
        captions: [
          "Have a small collection of books",
          "Have a large collection of books"
        ]
      },
      {
        id: "O01",
        band: "ope",
        files: ["7u2d29", "wy6jdo"],
        scheme: "dark",
        active: false,
        captions: [
          "Have difficulty understanding abstract ideas",
          "Find it easy to understand abstract ideas"
        ]
      },
      {
        id: "O16",
        band: "ope",
        files: ["2kl0du", "nx2dvg"],
        scheme: "dark",
        active: false,
        captions: [
          "Prefer activities with concrete outcomes",
          "Prefer activities that provide a creative outlet"
        ]
      },
      {
        id: "O14",
        band: "ope",
        files: ["rh0frj", "gza5te"],
        scheme: "dark",
        active: false,
        captions: [
          "Imagine and think narrowly",
          "Imagine and think more deeply"
        ]
      },
      {
        id: "E08",
        band: "ope",
        files: ["yg4n99", "15sdju"],
        scheme: "dark",
        active: false,
        captions: [
          "Don't express myself through my appearance",
          "Express myself through my appearance"
        ]
      }
    ]
  },
  con: {
    active: [
      {
        id: "C01",
        band: "con",
        files: ["c6f64n", "355zry"],
        scheme: "dark",
        active: true,
        captions: ["Sometimes late for meetings", "On time for meetings"]
      },
      {
        id: "C02",
        band: "con",
        files: ["lv2xfn", "4gq0j6"],
        scheme: "dark",
        active: true,
        captions: [
          "Not bothered by disorder",
          "Want everything to be ’just right’"
        ]
      },
      {
        id: "C03",
        band: "con",
        files: ["xl5f41", "m81l92"],
        scheme: "dark",
        active: true,
        captions: ["Leave my belongings behind", "Take my belongings with me"]
      },
      {
        id: "C04",
        band: "con",
        files: ["20poib", "msmnpz"],
        scheme: "dark",
        active: true,
        captions: ["Leave things unfinished", "Finish what I start"]
      },
      {
        id: "C06",
        band: "con",
        files: ["cy8n6m", "qcaa6d"],
        scheme: "dark",
        active: true,
        captions: [
          "Don’t need order and organisation",
          "Love order and organisation"
        ]
      },
      {
        id: "C07",
        band: "con",
        files: ["jh2gmp", "xjk5iw"],
        scheme: "dark",
        active: true,
        captions: ["Leave chores for later", "Get chores done right away"]
      },
      {
        id: "C08",
        band: "con",
        files: ["gs6om9", "vcnr1x"],
        scheme: "dark",
        active: true,
        captions: ["Leave a mess in my room", "Keep my room tidy"]
      },
      {
        id: "C10",
        band: "con",
        files: ["kf9kcv", "818if2"],
        scheme: "dark",
        active: true,
        captions: ["Do not plan ahead", "Like to plan ahead"]
      },
      {
        id: "C11",
        band: "con",
        files: ["41c00n", "5bufvc"],
        scheme: "dark",
        active: true,
        captions: ["Dislike routine", "Follow a schedule"]
      },
      {
        id: "C14",
        band: "con",
        files: ["qzhnyn", "7tbw5n"],
        scheme: "dark",
        active: true,
        captions: [
          "Put things back where ever there is space",
          "Put things back in their proper place"
        ]
      }
    ],
    research: [
      {
        id: "C12",
        band: "con",
        files: ["fiivcd", "q1z8re"],
        scheme: "dark",
        active: false,
        captions: ["Act free and wild", "Follow all safety rules"]
      },
      {
        id: "C13",
        band: "con",
        files: ["9ydbra", "p4cede"],
        scheme: "dark",
        active: false,
        captions: [
          "Believe laws should be loosely enforced",
          "Believe laws should be strictly enforced"
        ]
      },
      {
        id: "C05",
        band: "con",
        files: ["uh37yu", "l9ssbw"],
        scheme: "dark",
        active: false,
        captions: ["Break rules", "Follow rules"]
      },
      {
        id: "C15",
        band: "con",
        files: ["e7cqz5", "knvtym"],
        scheme: "dark",
        active: false,
        captions: ["Do just enough to get by", "Exact and precise in my work"]
      },
      {
        id: "C09",
        band: "con",
        files: ["qc3nm4", "oywmx3"],
        scheme: "dark",
        active: false,
        captions: ["Easily distracted", "Keep my mind on the task"]
      }
    ]
  },
  ext: {
    active: [
      {
        id: "E01",
        band: "ext",
        files: ["xk1t9s", "hjbfjw"],
        scheme: "dark",
        active: true,
        captions: ["Keep in the background", "The life of the party"]
      },
      {
        id: "E02",
        band: "ext",
        files: ["ov6y33", "w6pfn2"],
        scheme: "dark",
        active: true,
        captions: ["Tend to listen", "Tend to talk"]
      },
      {
        id: "E03",
        band: "ext",
        files: ["33ztg3", "tkxe19"],
        scheme: "dark",
        active: true,
        captions: [
          "Retreat from others",
          "Don’t mind being the center of attention"
        ]
      },
      {
        id: "E04",
        band: "ext",
        files: ["wdimib", "t0j9sb"],
        scheme: "dark",
        active: true,
        captions: ["Last to speak up", "First to speak up"]
      },
      {
        id: "E06",
        band: "ext",
        files: ["d629um", "nbsboa"],
        scheme: "dark",
        active: true,
        captions: ["Don’t talk a lot", "Talk a lot"]
      },
      {
        id: "E07",
        band: "ext",
        files: ["a9hrtp", "wpb31w"],
        scheme: "dark",
        active: true,
        captions: [
          "Talk with the same group of people at parties",
          "Talk to a lot of different people at parties"
        ]
      },
      {
        id: "E10",
        band: "ext",
        files: ["2ipjmp", "jso0by"],
        scheme: "dark",
        active: true,
        captions: [
          "Quiet around strangers",
          "Start conversations with strangers"
        ]
      },
      {
        id: "E11",
        band: "ext",
        files: ["iql46z", "lkeetw"],
        scheme: "dark",
        active: true,
        captions: ["Prefer smaller gatherings", "Prefer large gatherings"]
      },
      {
        id: "E12",
        band: "ext",
        files: ["8t18qx", "7uz354"],
        scheme: "dark",
        active: true,
        captions: [
          "Feel uncomfortable around others",
          "Feel at ease with people"
        ]
      },
      {
        id: "E13",
        band: "ext",
        files: ["b5jg92", "1yrdwt"],
        scheme: "dark",
        active: true,
        captions: [
          "Like my personal space",
          "Feel comfortable with close contact"
        ]
      }
    ],
    research: [
      {
        id: "E05",
        band: "ext",
        files: ["5537zw", "ac87d2"],
        scheme: "dark",
        active: false,
        captions: ["Sit back", "Take charge"]
      },
      {
        id: "E16",
        band: "ext",
        files: ["pwppf3", "1qhzmt"],
        scheme: "dark",
        active: false,
        captions: [
          "Quietly support teams at home",
          "Loudly support sport teams at events"
        ]
      },
      {
        id: "E15",
        band: "ext",
        files: ["chx8bv", "mrwrht"],
        scheme: "dark",
        active: false,
        captions: ["Love to be in the shade", "Love to tan in the sun"]
      },
      {
        id: "E17",
        band: "ext",
        files: ["h5zcsq", "syhqv8"],
        scheme: "dark",
        active: false,
        captions: [
          "Attend intimate gatherings",
          "Attend a lot of large social events"
        ]
      }
    ]
  },
  agr: {
    active: [
      {
        id: "A01",
        band: "agr",
        files: ["q5rxd5", "354ed1"],
        scheme: "dark",
        active: true,
        captions: [
          "Direct and to the point, irrespective of how it makes others feel",
          "Considered and concerned about how I make others feel"
        ]
      },
      {
        id: "A02",
        band: "agr",
        files: ["vmleti", "p5kj15"],
        scheme: "dark",
        active: true,
        captions: [
          "Do not know how to comfort others",
          "Know how to comfort others"
        ]
      },
      {
        id: "A03",
        band: "agr",
        files: ["ulrw02", "xb56hu"],
        scheme: "dark",
        active: true,
        captions: ["Make fun of others", "Show concern for others"]
      },
      {
        id: "A04",
        band: "agr",
        files: ["v0y22y", "v2071g"],
        scheme: "dark",
        active: true,
        captions: ["Don’t have a soft side", "Have a soft heart"]
      },
      {
        id: "A06",
        band: "agr",
        files: ["qg5u8s", "sbsjy9"],
        scheme: "dark",
        active: true,
        captions: [
          "Can’t be bothered with other’s needs",
          "Take time out for others"
        ]
      },
      {
        id: "A07",
        band: "agr",
        files: ["88jsik", "y9aply"],
        scheme: "dark",
        active: true,
        captions: [
          "Do not tolerate a lot from others",
          "Tolerate a lot from others"
        ]
      },
      {
        id: "A10",
        band: "agr",
        files: ["0duh0q", "lhgdgi"],
        scheme: "dark",
        active: true,
        captions: [
          "Forget social etiquette, consider only myself",
          "Follow social etiquette, be polite in public"
        ]
      },
      {
        id: "A11",
        band: "agr",
        files: ["2zkqko", "tohghv"],
        scheme: "dark",
        active: true,
        captions: ["Put the needs of others first", "Put my needs first"]
      },
      {
        id: "E14",
        band: "agr",
        files: ["xomole", "6wkvcz"],
        scheme: "dark",
        active: true,
        captions: ["Focused on self", "Focused on team"]
      },
      {
        id: "A14",
        band: "agr",
        files: ["7vqhnj", "uwowyl"],
        scheme: "dark",
        active: true,
        captions: ["Take no time for others", "Like to do things for others"]
      }
    ],
    research: [
      {
        id: "A13",
        band: "agr",
        files: ["2ugl4x", "rlnywy"],
        scheme: "dark",
        active: false,
        captions: [
          "Take advantage of when there is an opportunity",
          "Always have good intentions no matter the situation"
        ]
      },
      {
        id: "A15",
        band: "agr",
        files: ["c55kpb", "ho6pxs"],
        scheme: "dark",
        active: false,
        captions: ["Silent in the bath", "Sing in the bath"]
      },
      {
        id: "A05",
        band: "agr",
        files: ["acjigh", "zhiz6z"],
        scheme: "dark",
        active: false,
        captions: [
          "Not interested in other people’s problems",
          "Invested in other people’s problems"
        ]
      },
      {
        id: "A08",
        band: "agr",
        files: ["hwfy1r", "2jew1n"],
        scheme: "dark",
        active: false,
        captions: ["Seek conflict", "Avoid conflict"]
      },
      {
        id: "A09",
        band: "agr",
        files: ["59eary", "dg4797"],
        scheme: "dark",
        active: false,
        captions: ["Intervene", "Don’t intervene"]
      },
      {
        id: "A12",
        band: "agr",
        files: ["d48n62", "hii7b1"],
        scheme: "dark",
        active: false,
        captions: ["Think of my own personal gain", "Think of others first"]
      }
    ]
  },
  neu: {
    active: [
      {
        id: "N01",
        band: "neu",
        files: ["n94dmr", "6xr7lv"],
        scheme: "dark",
        active: true,
        captions: ["Not easily bothered by things", "Easily bothered by things"]
      },
      {
        id: "N03",
        band: "neu",
        files: ["wjpggx", "4owc8a"],
        scheme: "dark",
        active: true,
        captions: ["Generally relaxed about things", "Worry about things"]
      },
      {
        id: "N04",
        band: "neu",
        files: ["c3wxn9","j313z7"],
        scheme: "dark",
        active: true,
        captions: ["Rarely lose my composure", "Get easily agitated"]
      },
      {
        id: "N05",
        band: "neu",
        files: ["6iscly","dkajug"],
        scheme: "dark",
        active: true,
        captions: ["Rarely become overwhelmed", "Become overwhelmed by events"]
      },
      {
        id: "N06",
        band: "neu",
        files: ["4cnuzz","r377gb"],
        scheme: "dark",
        active: true,
        captions: [
          "Don’t worry about things that have already happened",
          "Worry about things that have already happened"
        ]
      },
      {
        id: "N07",
        band: "neu",
        files: ["knknju", "j0003j"],
        scheme: "dark",
        active: true,
        captions: ["Have stable mood", "Have frequent mood swings"]
      },
      {
        id: "N09",
        band: "neu",
        files: ["jdzz4l","u9fo6w"],
        scheme: "dark",
        active: true,
        captions: [
          "Remain calm under pressure",
          "Lose my composure under pressure"
        ]
      },
      {
        id: "N10",
        band: "neu",
        files: ["8akx8i","89ltot"],
        scheme: "dark",
        active: true,
        captions: ["Seldom feel blue", "Often feel blue"]
      },
      {
        id: "N11",
        band: "neu",
        files: ["3zd8ne","7mh8bv"],
        scheme: "dark",
        active: true,
        captions: ["Rarely down in the dumps", "Often down in the dumps"]
      },
      {
        id: "N12",
        band: "neu",
        files: ["eo23yr","ithx6s"],
        scheme: "dark",
        active: true,
        captions: [
          "Feel comfortable with myself",
          "Not comfortable with myself"
        ]
      }
    ],
    research: [
      {
        id: "N14",
        band: "neu",
        files: ["pn8hd6", "i1ofuv"],
        scheme: "dark",
        active: false,
        captions: [
          "Only use medicine when I have to",
          "Use a lot of medicine and vitamins to help with how I feel"
        ]
      },
      {
        id: "N02",
        band: "neu",
        files: ["gd06r2","wubql2"],
        scheme: "dark",
        active: false,
        captions: ["Rarely get irritated", "Often get irritated"]
      },
      {
        id: "N08",
        band: "neu",
        files: ["icibna", "w4fgc1"],
        scheme: "dark",
        active: false,
        captions: [
          "Keep my emotions under control",
          "Struggle to keep my emotions under control"
        ]
      },
      {
        id: "N13",
        band: "neu",
        files: ["8reooo", "4vco2k"],
        scheme: "dark",
        active: false,
        captions: ["Try to keep things calm", "Lose my composure easily"]
      }
    ]
  }
};
